import { Component } from '@angular/core';
import { SigninComponent, SigninManager } from 'sham-components/shared/auth';
import { SuperAdminSigninManager } from '../../../services/signin-manager.service';

@Component({
  selector: 'app-super-admin-signin',
  imports: [SigninComponent],
  templateUrl: './super-admin-signin.html',
  providers: [{ provide: SigninManager, useClass: SuperAdminSigninManager }],
})
export class SuperAdminSigninComponent {}
